export function colorIdentifier(state) {
  let color;
  switch (state.toUpperCase()) {
    case "NUEVO":
      color = "error";
      break;
    case "INFORME EN PROCESO":
      color = "info";
      break;
    case "INFORME ENVIADO":
      color = "info";
      break;
    case state.toUpperCase().match("INTIMACIÓN")?.input:
      color = "primary";
      break;
    case "SENTENCIA":
      color = "success";
      break;
    case "COBRADO":
      color = "success";
      break;
    default:
      color = "warning";
      break;
  }
  return color;
};

export function resumeJurisdiction(jurisdiccion) {
  let rta = jurisdiccion;
  switch (jurisdiccion.toUpperCase()) {
    case "CÁMARA NACIONAL DE APELACIONES EN LO CIVIL":
      rta = "CIV";
      break;
    case "CÁMARA NACIONAL DE APELACIONES EN LO CONTENCIOSO ADMINISTRATIVO FEDERAL":
      rta = "CAF";
      break;
    case "CÁMARA NACIONAL DE APELACIONES EN LO CIVIL Y COMERCIAL FEDERAL":
      rta = "CCF";
      break;
    case "CÁMARA NACIONAL ELECTORAL":
      rta = "CNE";
      break;
    case "CAMARA FEDERAL DE LA SEGURIDAD SOCIAL":
      rta = "CSS";
      break;
    case "CÁMARA NACIONAL DE APELACIONES EN LO PENAL ECONÓMICO":
      rta = "CPE";
      break;
    case "CÁMARA NACIONAL DE APELACIONES DEL TRABAJO":
      rta = "CNT";
      break;
    case "CAMARA CRIMINAL Y CORRECCIONAL FEDERAL":
      rta = "CFP";
      break;
    case "CAMARA NACIONAL DE APELACIONES EN LO CRIMINAL Y CORRECCIONAL":
      rta = "CCC";
      break;
    case "CAMARA NACIONAL DE APELACIONES EN LO COMERCIAL":
      rta = "COM";
      break;
    case "CAMARA FEDERAL DE CASACIÓN PENAL":
      rta = "CPF";
      break;
    case "CAMARA NACIONAL CASACION PENAL":
      rta = "CPN";
      break;
    case "JUSTICIA FEDERAL DE BAHIA BLANCA":
      rta = "FBB";
      break;
    case "JUSTICIA FEDERAL DE COMODORO RIVADAVIA":
      rta = "FCR";
      break;
    case "JUSTICIA FEDERAL DE CÓRDOBA":
      rta = "FCB";
      break;
    case "JUSTICIA FEDERAL DE CORRIENTES":
      rta = "FCT";
      break;
    case "JUSTICIA FEDERAL DE GENERAL ROCA":
      rta = "FGR";
      break;
    case "JUSTICIA FEDERAL DE LA PLATA":
      rta = "FLP";
      break;
    case "JUSTICIA FEDERAL DE MAR DEL PLATA":
      rta = "FMP";
      break;
    case "JUSTICIA FEDERAL DE MENDOZA":
      rta = "FMZ";
      break;
    case "JUSTICIA FEDERAL DE POSADAS":
      rta = "FPO";
      break;
    case "JUSTICIA FEDERAL DE PARANÁ":
      rta = "FPA";
      break;
    case "JUSTICIA FEDERAL DE RESISTENCIA":
      rta = "FRE";
      break;
    case "JUSTICIA FEDERAL DE SALTA":
      rta = "FSA";
      break;
    case "JUSTICIA FEDERAL DE ROSARIO":
      rta = "FRO";
      break;
    case "JUSTICIA FEDERAL DE SAN MARTIN":
      rta = "FSM";
      break;
    case "JUSTICIA FEDERAL DE TUCUMAN":
      rta = "FTU";
      break;
    case "CORTE SUPREMA DE JUSTICIA DE LA NACIÓN":
      rta = "CSJ";
      break;
  }
  return rta;
};

export function DateFormat(val) {
  if (!val) return "";
  const date = new Date(val); // Convierte el string a un objeto Date 
  const anio = date.getUTCFullYear();
  const mes = String(date.getUTCMonth() + 1).padStart(2, "0");
  const dia = String(date.getUTCDate()).padStart(2, "0");
  return `${anio}-${mes}-${dia}`;
}

export function DateTimeFormat(val) {
  if (!val) return "";

  const date = new Date(val); // Convierte el string a un objeto Date
  const anio = date.getUTCFullYear();
  const mes = String(date.getUTCMonth() + 1).padStart(2, "0");
  const dia = String(date.getUTCDate()).padStart(2, "0");
  const horas = String(date.getUTCHours()).padStart(2, "0");
  const minutos = String(date.getUTCMinutes()).padStart(2, "0");
  const segundos = String(date.getUTCSeconds()).padStart(2, "0");

  return `${anio}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
}

export function serviceResponseSuccess(data="", message="") {
  return {
    success: true,
    data,
    message,
  }
}

export function serviceResponseError(message="") {
  return {
    error: true,
    message,
  };
}